import React from "react";
import PropTypes from "prop-types";
import { isIOS } from "react-device-detect";

class AppLayout extends React.Component {
  constructor(props) {
    super(props);

    // this.props.saveMobileLayout(0);
    this.getHeight = this.getHeight.bind(this);
  }

  getHeight() {
    setTimeout(() => {
      const height = this.divElement.clientHeight;

      this.props.saveHeight(height);
      this.props.checkMobileLayout(isIOS, height);
    }, 0);
  }

  componentDidMount() {
    // this.getHeight();
    this.props.showError();
    // alert(
    //   "marginLayout   " +
    //     this.props.marginLayout +
    //     "    " +
    //     this.divElement.clientHeight,
    // );
  }

  render() {
    return (
      <div
        ref={divElement => {
          this.divElement = divElement;
        }}
      >
        <div
          style={{ height: Number(this.props.marginLayout) || 0 }}
          className="addition-header"
        />
        {this.props.children}
      </div>
    );
  }
}

AppLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  saveHeight: PropTypes.func,
  showError: PropTypes.func,
  checkMobileLayout: PropTypes.func,
  marginLayout: PropTypes.number,
  saveMobileLayout: PropTypes.func,
};

export default AppLayout;
